import { useForm } from 'components/form/Form';
import { classNames } from 'libs/react';
import { FormRadio } from './FormRadio';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormRadioGroup } from 'components/form/FormRadioGroup';
import { React } from 'libs/react';
import './FormRadioList.scss';
/**
 * @component FormRadioList
 * @since 1.0.0
 */
export function FormRadioList(props) {
    let { name, style, label, infos, value, error, initial, options, required, disabled } = Object.assign({ style: 'normal' }, props);
    const form = useForm();
    if (options == null) {
        options = [];
    }
    if (value == null) {
        value = initial;
    }
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-radio-list', 'form-radio-list--' + style, { 'form-radio-list--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(FormRadioGroup, { style: style, label: label, infos: infos, required: required, disabled: disabled }, options.map((option, key) => (React.createElement(FormRadio, { key: key, name: name, label: option.label, infos: option.infos, value: option.value, picto: option.picto, checked: option.value == value, silenced: true, onChange: (value) => props.onChange && props.onChange(option.value) })))),
        React.createElement(FormFieldError, { error: error })));
}
